import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { LabelCreateRequest, LabelResponse, LabelUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { LabelDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '..';

@RegisterEntityHandler('label')
@Injectable()
export class LabelHandler extends EntityHandler<LabelResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    entities = [
        { key: 'trip', value: this.admin.i18n.instant('ADMIN.EDITORS.LABEL.ENTITIES.TRIP') }
    ];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listLabels/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listLabels(ownerId, false, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'label',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.LABELS'),
        }));
    }

    getEntity(id: string): Promise<LabelResponse> {
        return this.admin.getCached(`getLabel/${id}`, api => api.entities.getLabel(id), 10);
    }

    createEntity(ownerId: string, entity: LabelCreateRequest): Promise<LabelResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createLabel(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateLabel(entity.id, { state: state as any }));
    }   

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.LABEL.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.label),
            { ...grid.IdNameArrayTextColumn('values', 'VALUES'), filter: null },
            {
                ...grid.TextColumn('entities', 'ENTITIES'),
                format: (col, row) => {
                    return (row[col.field] || []).map(x => this.entities.find(e => e.key === x)?.value || x).join(', ');
                },
                filter: null
            },
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<LabelResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new LabelDetailsSectionHandler(this.admin, ownerId, false, this.entities),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: LabelUpdateRequest, sections: FormSectionHandler<LabelResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'label',
            entity: {}, // set up some defaults if you want
            sections: [
                new LabelDetailsSectionHandler(this.admin, ownerId, true, this.entities),
            ],
        });
    }

}












